import { Switch } from '@fluentui/react-components';
import { setAiHubUserStorageData } from '@office-start/ai-hub-toggle-service';
import { useLocStrings } from '@office-start/loc-service';
import { logUserAction } from '@office-start/telemetry-service';
import React from 'react';
import { useAiHubHeaderStyles } from './AiHubHeader.styles';
export var AiHubHeader = function () {
    var _a;
    var styles = useAiHubHeaderStyles();
    var locStrings = useLocStrings().data;
    function onAiHubToggleClick() {
        logAiHubToggleToOptOut();
        setAiHubUserStorageData(false).finally(function () {
            var newPath = '/v2/?optoutaihub';
            window.location.href = "".concat(newPath);
        });
    }
    var logAiHubToggleToOptOut = function () {
        logUserAction({
            type: 'Click',
            id: 'AiHubHeaderToggled',
            area: 'AiHubHeader',
            result: 'OptOut',
            target: 'AiHubHeader',
            eventName: 'optedOutOfAiHub',
        });
    };
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.toggleContainer },
            React.createElement(Switch, { label: (_a = locStrings === null || locStrings === void 0 ? void 0 : locStrings.aiHubHeaderResources) === null || _a === void 0 ? void 0 : _a.aiHubToggleLabel, defaultChecked: true, onChange: function () { return onAiHubToggleClick(); }, labelPosition: "before" }))));
};
//# sourceMappingURL=AIHubHeader.js.map